import { useLocation } from "react-router-dom" // TODO: note will need to convert back to v6
import { getHighlighterKey } from "../utils"
import { useHighlighter } from "./highlighter"
import {
  HIGHLIGHT_CLASSNAME,
  HIGHLIGHT_CONTAINER_PASSAGE,
  HIGHLIGHT_CONTAINER_QUESTION
} from "../../constants"

type HighlighterScope = "q" | "p"

export const useScopedHighlighter = (
  scope: HighlighterScope,
  entityId: string
) => {
  const location = useLocation()
  const searchParams = new URLSearchParams(location.search)

  const highlighterKey = getHighlighterKey(
    scope,
    searchParams.get("userId"),
    searchParams.get("id"),
    entityId
  )
  const containerId =
    scope === "q" ? HIGHLIGHT_CONTAINER_QUESTION : HIGHLIGHT_CONTAINER_PASSAGE
  const highlighter = useHighlighter(
    HIGHLIGHT_CLASSNAME,
    highlighterKey,
    containerId
  )

  return highlighter
}
